// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Dy-z","tooltipWrapper":"Ey-z","icon":"Fy-z","tooltip":"Gy-z","content":"Hy-z"};